import styled from 'styled-components';

export default styled.h3`
  font-size: 23px;
  font-weight: 500;
  margin: 0 0 17px;
`;
